<template>
  <div>
    <LoadingOverlay
      v-if="latestRequestFormValues === undefined"
      :globalDisplay="true"
    />
    <Header> Change Request Form </Header>
    <div class="tiled-bar-image"></div>
    <Main>
      <div class="flex justify-center gap-2">
        <Button color="gray" size="md" @click="toPreviousPage()">
          Cancel
        </Button>
        <Button color="blue" size="md" @click="toNewRequestForm()">
          Create a New Student Request Instead
        </Button>
      </div>
      <RequestForm
        ref="requestForm"
        :defaultValues="latestRequestFormValues"
        :enableSchoolYearSelection="false"
        :allowDistrictSelection="false"
        @submit="checkChanges"
        @editSuggestedStudent="onEditSuggestedStudent"
      />
      <Modal
        ref="checkChangesModal"
        size="full"
        width="max"
        :onSuccess="
          () =>
            onSubmit(
              submitParams.resolve,
              submitParams.reject,
              submitParams.clonedFormValues,
              submitParams.isSibling
            )
        "
      >
        <template #title>Confirm changes</template>
        <template #content>
          <div class="divide-y divide-gray-200">
            <template v-for="(item, index) in changes.contactInfo">
              <ChangeItem
                v-for="(key, indexCount) in item"
                :key="key + indexCount"
                :data="[
                  key,
                  (defaultValues.contactInfo[index]
                    ? defaultValues.contactInfo[index]
                    : { email: '', name: '', phone: '', relationship: '' })[
                    key
                  ],
                  (formValues.contactInfo[index]
                    ? formValues.contactInfo[index]
                    : { email: '', name: '', phone: '', relationship: '' })[
                    key
                  ],
                  `Contact #${index + 1} ${
                    key.charAt(0).toUpperCase() + key.slice(1)
                  }`
                ]"
                :programs="programList"
              />
            </template>
            <ChangeItem
              v-for="(key, index) in changes.studentInfo"
              :key="key + index"
              :data="[
                key,
                defaultValues.studentInfo[key],
                formValues.studentInfo[key]
              ]"
              :programs="programList"
            />
            <ChangeItem
              v-for="(key, index) in changes.studentHome"
              :key="key + index"
              :data="[
                key,
                defaultValues.studentHome[key],
                formValues.studentHome[key]
              ]"
              :programs="programList"
            />
            <ChangeItem
              v-for="(key, index) in changes.transDetails"
              :key="key + index"
              :data="[
                key,
                defaultValues.transDetails[key],
                formValues.transDetails[key]
              ]"
              :programs="programList"
              :scheduleChange="scheduleChange"
              :schedule="[
                formValues.transDetails.inboundDayDifferent,
                formValues.transDetails.outboundDayDifferent
              ]"
              :prevSchedule="[
                defaultValues.transDetails.inboundDayDifferent,
                defaultValues.transDetails.outboundDayDifferent
              ]"
            />
            <ChangeItem
              v-for="(key, index) in changes.vestInfo"
              :key="key + index"
              :data="[
                key,
                defaultValues.vestInfo[key],
                formValues.transDetails.specialNeeds.vestInfo[key],
              ]"
            />
          </div>
        </template>
        <template #footer="slotProps">
          <SubmitButton
            type="button"
            class="rounded-md font-medium text-sky-900 bg-sky-600 px-3 py-2 hover:bg-blue-200 transition-colors shadow-sm"
            :submitting="submitting"
            @click="() => slotProps.closeModal(true)">
            Confirm and submit
          </SubmitButton>
        </template>
      </Modal>
    </Main>
  </div>
</template>

<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
</style>

<script>
import Header from '../components/Header.vue'
import Main from '../components/Main.vue'
import Button from '../components/Button.vue'
import SubmitButton from '../components/SubmitButton.vue'
import LoadingOverlay from '../components/LoadingOverlay.vue'
import Modal from '../components/Modal.vue'
import ChangeItem from '../components/items/ChangeItem.vue'

import RequestForm from '../pages/RequestForm.vue'

import changeRequestFormService from '../services/pages/changeRequestForm.js'
import requestFormService from '../services/formSubmission/requestForm.js'

import user from '../services/user/user.js'
import view from '../services/user/view.js'
import notifications from '../services/notifications.js'

import { reduce, isNil, isEqual, isArray, cloneDeep } from 'lodash'
import fastDeepEquals from 'fast-deep-equal'

import settings from '../services/settings.js'

import districtUtil from '../services/districts.js'
import partitionUtil from '../services/partitions.js'

import DROPDOWN_LISTS from '../components/DropdownLists.json'

import events from '../services/events.js'
import uiData from '../services/uiData.js'

import time from '../services/utils/time.js'


export default {
  components: {
    Header,
    Main,
    Button,
    SubmitButton,
    LoadingOverlay,
    RequestForm,
    Modal,
    ChangeItem
  },
  props: {},
  data() {
    return {
      user: undefined,
      view: undefined,

      dbId: -1,
      latestRequestFormValues: undefined,
      constantRequestFormValues: {},
      submissionResponse: undefined,
      changes: {},
      formValues: {},
      defaultValues: {},
      programList: [],
      weekdays: DROPDOWN_LISTS.weekdays,
      submitParams: {},
      scheduleChange: false,
      submitting: false,
    }
  },
  eventCallbackIds: {},
  methods: {
    formatTime(initTime) {
      if (initTime == undefined) {
        return undefined
      }
      var HH = initTime.substring(0, 2)
      var MM = initTime.substring(3, 5)
      return HH + ':' + MM
    },
    minutesOff(initTime, minutes) {
      if (initTime == undefined) {
        return undefined
      }
      var date = new Date()
      var HH = initTime.substring(0, 2)
      var MM = Number(initTime.substring(3, 5)) + minutes
      date.setHours(HH, MM)
      var newHH = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var newMM = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      return newHH + ':' + newMM
    },
    checkDifferentTimes(source, weekdaysSource, formValues, options = {}) {
      if (source == undefined) {
        return
      }
      if (weekdaysSource == undefined) {
        return
      }
      for (const weekday of weekdaysSource) {
        if (!options.skipPickup) {
          if (weekday.arrivalTime !== source.arrivalTime ||
              weekday.programStartTime !== source.programStartTime) {
            formValues.diffPickupTimes = true
          }
        }
        if (!options.skipDropoff) {
          if (weekday.programEndTime !== source.programEndTime ||
              weekday.departureTime !== source.departureTime) {
            formValues.diffDropoffTimes = true
          }
        }
      }
    },
    checkDifferentAddresses(source, weekdaysSource, studentHomeAddress, formValues) {
      if (source == undefined) {
        return
      }
      if (weekdaysSource == undefined) {
        return
      }
      for (const weekday of weekdaysSource) {
        if (fastDeepEquals(weekday.pickupAddress, studentHomeAddress) == false &&
          fastDeepEquals(weekday.pickupAddress, source?.scheduleRequest?.pickupAddress) == false) {
          formValues.diffPickupTimes = true
        }
        if (fastDeepEquals(weekday.dropoffAddress, studentHomeAddress) == false &&
          fastDeepEquals(weekday.dropoffAddress, source?.scheduleRequest?.dropoffAddress) == false) {
          formValues.diffDropoffTimes = true
        }
      }
    },
    setDayString(day) {
      return DROPDOWN_LISTS.weekdays[day]
    },
    toNewRequestForm() {
      settings.requestForm.pullInit = false
      this.$router.push({
        name: 'NewRequestForm'
      })
    },
    toPreviousPage() {
      settings.requestForm.pullInit = false
      this.$router.back()
    },
    async calculateLeadTime(districtList) {

      await Promise.all([ districtUtil.getDistrictFromServer(), partitionUtil.getPartitionFromServer() ])

      let leadTimes = [1]
      for (const dist of districtList) {
        let districtObj = await districtUtil.getDistrictByCode(dist)
        let result = await partitionUtil.getPartition(districtObj['partition_id'])
        if (result['ui_data']['request_lead_time']) {
          leadTimes.push(result['ui_data']['request_lead_time'])
        }
      }
      return Math.max(...leadTimes)
    },
    async serveUiData() {
      this.$refs.requestForm.requireBoosterSeat(false)

      let districtList = this.view.getDistrict()
      if (districtList.length > 0){
        await this.calculateLeadTime(districtList).then(result => {
          this.$refs.requestForm.setLeadTime(result)
        })
      }
      uiData.using('partition', (uiDataObj) => {
        for (const partitionId of this.view.getPartition()) {
          if (uiDataObj[partitionId] === undefined) {
            continue
          }
          if ('conditions' in uiDataObj[partitionId]) {
            let conditions = uiDataObj[partitionId].conditions
            if ('require_booster_seat' in conditions) {
              for (const form of conditions['require_booster_seat']['forms']) {
                if (form === 'new_request') {
                  let gradeMin = conditions['require_booster_seat']['grade_min']
                  let gradeMax = conditions['require_booster_seat']['grade_max']
                  let warningMessage = conditions['require_booster_seat']['warning_message']
                  this.$refs.requestForm.requireBoosterSeat(true, gradeMin, gradeMax, warningMessage)
                }
              }
            }
          }
          if ('request_lead_time' in uiDataObj[partitionId] && districtList.length == 0) {
            let leadTime = uiDataObj[partitionId]['request_lead_time']
            this.$refs.requestForm.setLeadTime(leadTime)
          }
        }
      })
    },
    async onSubmit(resolve, reject, clonedFormValues, isSibling) {
      try {
        this.submitting = true
        let response = await changeRequestFormService.putChangeStudentForm(clonedFormValues, this.dbId)
        if (response.status !== 201) {
          throw new Error(response.statusText)
        }
        this.submitting = false
        resolve(response)

        if (isSibling) {
          settings.requestForm.pullInit = true
          settings.requestForm.dbId = this.dbId
          this.$refs.requestForm.clearStudentInfo()
          this.$refs.requestForm.updateBuildingSelection()
          notifications.pushInfo('All validation complete, form submitted, continue to fill out the next form.')
          window.scrollTo(0, 0)
          this.$router.push({
            name: 'NewRequestForm'
          })
        } else {
          this.$router.push({
            name: 'StudentList'
          })
          notifications.pushInfo('All validation complete, form submitted.')
        }
      } catch (err) {
        this.submitting = false
        reject(err)
        console.log(err)
      }
    },
    onEditSuggestedStudent(dbId) {
      settings.requestForm.dbId = dbId
      this.latestRequestFormValues = {}
      this.dbId = dbId
      this.setRequestFormValues(this.dbId)
      this.serveUiData()
    },
    async setRequestFormValues(dbId) {
      window.scrollTo(0, 0)
      try {
        this.latestRequestFormValues = await changeRequestFormService.setRequestFormValues(dbId)
        // this.latestRequestFormValues.schoolYear = is present in existing students

        this.constantRequestFormValues = cloneDeep(this.latestRequestFormValues)
      }
      catch (error) {
        console.error(error)
        this.$router.push({
          name: 'NewRequestForm'
        })
      }
    },
    compareObjects(a, b) {
      return reduce(
        a,
        (result, value, key) => {
          let matchValue = b[key]
          let compare = true
          switch (key) {
            case 'diffPickupAddress':
            case 'diffDropoffAddress':
            case 'aideOnetoOne':
            case 'enclosedVehicle':
            case 'weekdays':
            case 'diffPickupTimes':
            case 'diffDropoffTimes':
              compare = false
              break
            case 'schoolEndTime':
            case 'departureTime':
            case 'startTime':
            case 'arrivalTime':
              compare = false
              if (time.toDate(value)?.getTime() !== time.toDate(matchValue)?.getTime()) {
                return result.concat(key)
              }
              break
            case 'inboundDayDifferent':
            case 'outboundDayDifferent':
              if (key === 'inboundDayDifferent' && !a.diffPickupTimes && b.diffPickupTimes) {
                return result
              }
              else if (key === 'outboundDayDifferent' && !a.diffDropoffTimes && b.diffDropoffTimes) {
                return result
              }
              this.scheduleChange = true
              compare = false
              if (value.length !== matchValue.length) {
                return result.concat(key)
              }
              else {
                for (const dayObj of value) {
                  let matchDayObj = matchValue.find(el => el.day === dayObj.day)
                  if (matchDayObj === undefined) {
                    return result.concat(key)
                  }
                  let cloneDayObj = cloneDeep(dayObj)
                  let cloneMatchDayObj = cloneDeep(matchDayObj)
                  cloneDayObj.programTime = this.formatTime(cloneDayObj.programTime)
                  cloneDayObj.transportTime = this.formatTime(cloneDayObj.transportTime)
                  cloneMatchDayObj.programTime = this.formatTime(cloneMatchDayObj.programTime)
                  cloneMatchDayObj.transportTime = this.formatTime(cloneMatchDayObj.transportTime)
                  if (fastDeepEquals(cloneDayObj, cloneMatchDayObj) == false) {
                    return result.concat(key)
                  }
                }
              }
              break
            case 'specialNeeds':
              compare = false
              if (isEqual(value.needsList, matchValue.needsList)
                && Boolean(value.aide) == false
                && Boolean(matchValue.aide) == false) {
                return result
              }
              else if (value.aide != matchValue.aide) {
                return result.concat(key)
              }
              else {
                return result
              }
            default:
              if (isNil(matchValue)) {
                matchValue = ''
              }
          }
          if (compare) {
            if (isNil(value) && isNil(matchValue)) {
              return result
            } else {
              if (isNil(matchValue)) {
                return isEqual(value, matchValue) || isEqual(value, '')
                  ? result
                  : result.concat(key)
              } else if (isNil(value)) {
                return isEqual(value, matchValue) || isEqual('', matchValue)
                  ? result
                  : result.concat(key)
              } else {
                return isEqual(value, matchValue) ? result : result.concat(key)
              }
            }
          } else {
            return result
          }
        },
        []
      )
    },
    convertDataToAddress(data) {
      return `${data.street}${
        isNil(data.apartment) ? '' : ` #${data.apartment}`
      }, ${data.city}, ${data.state} ${data.zip_code}`
    },
    checkChanges(...params) {
      this.submitParams = {
        resolve: params[0],
        reject: params[1],
        clonedFormValues: params[2],
        isSibling: params[3],
      }
      this.$refs.checkChangesModal.setCloseCallback(this.submitParams.reject)
      // console.log(this.$refs.requestForm.formValues)
      const _ref = {
        formStudentHome: this.$refs.requestForm.formValues.studentHome,
        defaultStudentHome: this.defaultStudentHome[0],
        defaultTransDetails: this.defaultTransDetails[0]
      }
      this.defaultValues = {
        contactInfo: this.defaultContactInfo,
        studentHome: {
          ..._ref.defaultStudentHome,
          homeAddress: {
            street: _ref.defaultStudentHome.street,
            state: _ref.defaultStudentHome.state,
            apartment: _ref.defaultStudentHome.apartment,
            city: _ref.defaultStudentHome.city,
            zip_code: _ref.defaultStudentHome.zip_code
          }
        },

        studentInfo: this.defaultStudentInfo[0],
        transDetails: {
          ..._ref.defaultTransDetails,
          schoolName: _ref.defaultTransDetails.school?.name
        },
        vestInfo: {
          ..._ref.defaultTransDetails.specialNeeds.vestInfo,
        },
      }
      
      this.formValues = {
        contactInfo: cloneDeep(this.$refs.requestForm.formValues.contactInfo),
        studentHome: {
          ..._ref.formStudentHome,
          homeAddress: {
            street: _ref.formStudentHome.street,
            state: _ref.formStudentHome.state,
            apartment: _ref.formStudentHome.apartment,
            city: _ref.formStudentHome.city,
            zip_code: _ref.formStudentHome.zip_code
          }
        },
        studentInfo: cloneDeep(
          this.$refs.requestForm.formValues.studentInfo
        ),
        transDetails: cloneDeep(
          this.$refs.requestForm.formValues.transDetails
        )
      }

      const addressSections = [
        'street',
        'state',
        'apartment',
        'city',
        'zip_code'
      ]
      addressSections.forEach(item => {
        delete this.defaultValues.studentHome[item]
        delete this.formValues.studentHome[item]
      })

      delete this.formValues.transDetails.schoolDistrictId
      delete this.formValues.transDetails.schoolCode
      delete this.formValues.transDetails.counter

      this.formValues.transDetails.schoolAddress = this.formValues.transDetails.school.address
      this.formValues.transDetails.schoolName = this.formValues.transDetails.school.name

      if (this.defaultValues.transDetails.school) {
        this.defaultValues.transDetails.schoolAddress = this.defaultValues.transDetails.school.address
        this.defaultValues.transDetails.schoolName = this.defaultValues.transDetails.school.name
        delete this.defaultValues.transDetails.school
      }

      delete this.defaultValues.transDetails.isNewSchool
      delete this.formValues.transDetails.isNewSchool
      delete this.formValues.transDetails.school

      let contactInfoCompare
      if (this.formValues.contactInfo.length < this.defaultValues.contactInfo.length) {
        contactInfoCompare = this.defaultValues.contactInfo.map((item, index) =>
          this.compareObjects(
            this.formValues.contactInfo[index]
              ? this.formValues.contactInfo[index]
              : { email: '', name: '', phone: '', relationship: '' },
            item
          )
        )
      } else {
        contactInfoCompare = this.formValues.contactInfo.map((item, index) =>
          this.compareObjects(
            item,
            this.defaultValues.contactInfo[index]
              ? this.defaultValues.contactInfo[index]
              : { email: '', name: '', phone: '', relationship: '' }
          )
        )
      }

      if (isArray(this.formValues.transDetails.inboundDayDifferent)) {
        this.formValues.transDetails.inboundDayDifferent =
          this.formValues.transDetails.inboundDayDifferent.filter(
            el => this.formValues.transDetails.inboundDays.includes(el.day)
          )
      }
      if (isArray(this.formValues.transDetails.outboundDayDifferent)) {
        this.formValues.transDetails.outboundDayDifferent =
          this.formValues.transDetails.outboundDayDifferent.filter(
            el => this.formValues.transDetails.outboundDays.includes(el.day)
          )
      }
      this.formValues.transDetails.diffPickupTimes = false
      this.formValues.transDetails.diffDropoffTimes = false
      this.checkDifferentTimes(
        this.formValues.transDetails,
        this.formValues.transDetails.inboundDayDifferent,
        this.formValues.transDetails,
        { 'skipDropoff': true }
      )
      this.checkDifferentTimes(
        this.formValues.transDetails,
        this.formValues.transDetails.outboundDayDifferent,
        this.formValues.transDetails,
        { 'skipPickup': true }
      )
      this.checkDifferentAddresses(
        this.formValues.transDetails,
        this.formValues.transDetails.inboundDayDifferent,
        _ref.formStudentHome,
        this.formValues.transDetails,
        { 'skipDropoff': true }
      )
      this.checkDifferentAddresses(
        this.formValues.transDetails,
        this.formValues.transDetails.outboundDayDifferent,
        _ref.formStudentHome,
        this.formValues.transDetails,
        { 'skipPickup': true }
      )

      this.changes = {
        studentHome: this.compareObjects(
          this.formValues.studentHome,
          this.defaultValues.studentHome
        ),
        studentInfo: this.compareObjects(
          this.formValues.studentInfo,
          this.defaultValues.studentInfo
        ),
        contactInfo: contactInfoCompare,
        transDetails: this.compareObjects(
          this.formValues.transDetails,
          this.defaultValues.transDetails
        ),
        vestInfo: this.compareObjects(
          this.formValues.transDetails.specialNeeds.vestInfo,
          this.defaultValues.vestInfo,
        )
      }

      this.$refs.checkChangesModal.openModal()
    },
    checkUserCanViewPage() {
      if (!this.user.can('view_new_request_form')) {
        this.$router.push({
          name: 'StudentList'
        })
        return true
      }
    }
  },
  created() {
    this.$options.eventCallbackIds.viewUpdated = events.register(
      'viewUpdated',
      async () => {
        this.view = await view.get()
      }
    )
    this.$options.eventCallbackIds.uiDataUpdated = events.register(
      'uiDataUpdated',
      () => {
        this.serveUiData()
      }
    )
  },
  //beforeUnmount() {
  // eslint-disable-next-line
  beforeDestroy() {
    events.remove(
      'viewUpdated',
      this.$options.eventCallbackIds.viewUpdated
    )
    events.remove(
      'uiDataUpdated',
      this.$options.eventCallbackIds.uiDataUpdated
    )
  },
  async mounted() {
    this.user = await user.get()
    this.view = await view.get()
    if (this.checkUserCanViewPage()) {
      return
    }

    this.dbId = parseInt(settings.requestForm.dbId)
    console.log(this.dbId)
    if (this.dbId < 0) {
      this.$router.push({
        name: 'NewRequestForm'
      })
      return
    }
    requestFormService.getProgramFromServer()
      .then(
        result => {
          this.programList = result.data
        },
        error => {
          console.error(error)
        }
      )
    this.setRequestFormValues(this.dbId)
    this.serveUiData()
  },
  computed: {
    defaultStudentInfo() {
      if (this.constantRequestFormValues === undefined) {
        return
      }
      let fields = [
        'firstName',
        'middleName',
        'lastName',
        'dateOfBirth',
        'gender',
        'language',
        'grade',
        'studentId',
        'program',
        'marssCode'
      ]
      let ret = {}
      for (const field of fields) {
        ret[field] = this.constantRequestFormValues.student[field]
      }
      if (this.constantRequestFormValues?.scheduleRequest.notes.customProgram) {
        ret['customProgram'] = this.constantRequestFormValues?.scheduleRequest.notes.customProgram
      }
      ret['dbId'] = this.constantRequestFormValues.student.dbId
      return [ret]
    },
    defaultStudentHome() {
      return this.constantRequestFormValues
        ? [this.constantRequestFormValues.address]
        : ''
    },
    defaultContactInfo() {
      return this.constantRequestFormValues
        ? this.constantRequestFormValues.contacts
        : ''
    },
    defaultTransDetails() {
      let transDetails = {
        inboundDays: [],
        outboundDays: [],
        inboundDayDifferent: [],
        outboundDayDifferent: [],
        diffPickupTimes: false,
        diffDropoffTimes: false,
      }

      this.checkDifferentTimes(
        this.constantRequestFormValues.scheduleRequest,
        this.constantRequestFormValues.scheduleRequest.scheduleRequestWeekdays,
        transDetails
      )
      this.checkDifferentAddresses(
        this.constantRequestFormValues.scheduleRequest,
        this.constantRequestFormValues.scheduleRequest.scheduleRequestWeekdays,
        this.constantRequestFormValues.address,
        transDetails
      )
      if (this.constantRequestFormValues === undefined) {
        return [transDetails]
      }

      let today = new Date()
      if (
        this.constantRequestFormValues?.scheduleRequest.requestedStartDate &&
        new Date(this.constantRequestFormValues.scheduleRequest.requestedStartDate) > today
      ) {
        transDetails['startDate'] = this.constantRequestFormValues.scheduleRequest.requestedStartDate
      }

      transDetails['endDate'] = this.constantRequestFormValues?.scheduleRequest.requestedEndDate
      transDetails['school'] = this.constantRequestFormValues?.scheduleRequest.building
      for (const field of ['arrivalTime', 'departureTime', 'studentRelease']) {
        transDetails[field] = this.constantRequestFormValues?.scheduleRequest[field]
      }
      transDetails['arrivalTime'] = this.formatTime(transDetails['arrivalTime'])
      transDetails['departureTime'] = this.formatTime(transDetails['departureTime'])
      transDetails['startTime'] = this.constantRequestFormValues?.scheduleRequest.programStartTime
      transDetails['schoolEndTime'] = this.constantRequestFormValues?.scheduleRequest.programEndTime
      if (this.constantRequestFormValues?.scheduleRequest.pickupAddress) {
        transDetails['newPickupAddress'] = [
          this.constantRequestFormValues?.scheduleRequest.pickupAddress
        ]
      }
      if (this.constantRequestFormValues?.scheduleRequest.dropoffAddress) {
        transDetails['newDropoffAddress'] = [
          this.constantRequestFormValues?.scheduleRequest.dropoffAddress
        ]
      }

      if (this.constantRequestFormValues?.scheduleRequest.medicalNotes) {
        transDetails['medicalInfo'] = this.constantRequestFormValues?.scheduleRequest.medicalNotes
      }
      if (this.constantRequestFormValues?.scheduleRequest.notes.additional) {
        transDetails['additionalInfo'] = this.constantRequestFormValues.scheduleRequest.notes.additional
      }
      if (this.constantRequestFormValues?.scheduleRequest.notes.outbound) {
        transDetails['outboundInfo'] = this.constantRequestFormValues.scheduleRequest.notes.outbound
      }
      if (this.constantRequestFormValues?.scheduleRequest.notes.inbound) {
        transDetails['inboundInfo'] = this.constantRequestFormValues.scheduleRequest.notes.inbound
      }

      transDetails.specialNeeds = {needsList: []}

      let needsList = [
        'infoAide',
        'infoWheelchair',
        'infoSolo',
        'infoEnclosedVehicle',
        'infoBoosterSeat',
        'infoSafetyVest',
        'infoSafetyBeltLockingCover',
        'infoCarSeat'
      ]
      if (this.constantRequestFormValues?.scheduleRequest?.vestInfo) {
        transDetails.specialNeeds['vestInfo'] = this.constantRequestFormValues?.scheduleRequest.vestInfo
      }
      for (const need of needsList) {
        if (this.constantRequestFormValues?.scheduleRequest[need]) {
          transDetails.specialNeeds.needsList.push(need)
          if (need == 'infoAide') {
            transDetails.specialNeeds['aide'] = this.constantRequestFormValues?.scheduleRequest.infoAide
            transDetails.specialNeeds['aideOnetoOne'] = transDetails.specialNeeds.aide == 'A1:1' ? true : false
          }
        }
      }

      if (this.constantRequestFormValues?.scheduleRequest?.scheduleRequestWeekdays) {
        for (const weekday of this.constantRequestFormValues.scheduleRequest.scheduleRequestWeekdays) {
          if (weekday.isPickup) {
            transDetails.inboundDays.push(this.weekdays[weekday.weekday])
          }
          if (weekday.isDropoff) {
            transDetails.outboundDays.push(this.weekdays[weekday.weekday])
          }
        }

        for (const weekday of this.constantRequestFormValues.scheduleRequest.scheduleRequestWeekdays) {
          if (transDetails.diffPickupTimes) {
            if (weekday.isPickup) {
              transDetails.inboundDayDifferent.push({
                'day': this.setDayString(weekday.weekday),
                'programTime': weekday.programStartTime,
                'transportTime': weekday.arrivalTime,
                'diffAddress': true,
                'address': weekday.pickupAddress,
              })
            }
          }
          if (transDetails.diffDropoffTimes) {
            if (weekday.isDropoff) {
              transDetails.outboundDayDifferent.push({
                'day': this.setDayString(weekday.weekday),
                'programTime': weekday.programEndTime,
                'transportTime': weekday.departureTime,
                'diffAddress': true,
                'address': weekday.dropoffAddress,
              })
            }
          }
        }
      }

      return [transDetails]
    }
  }
}
</script>
